import React from "react";

const FailureIcon = ({
  width = 10,
  height = 10,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    className={className}
  >
    <path
      d="M9.80031 7.52658L6.3118 0.832836C6.17074 0.577514 5.97639 0.367391 5.74667 0.221842C5.51695 0.0762919 5.25926 0 4.99735 0C4.73545 0 4.47775 0.0762919 4.24804 0.221842C4.01832 0.367391 3.82397 0.577514 3.68291 0.832836L0.194395 7.52658C0.0711613 7.76426 0.00418151 8.03529 0.000189517 8.31241C-0.00380248 8.58954 0.055334 8.863 0.171653 9.10529C0.306136 9.37803 0.500792 9.60456 0.735729 9.76173C0.970665 9.91891 1.23746 10.0011 1.50884 9.9999H8.48587C8.75547 10.0032 9.02105 9.92422 9.25583 9.77084C9.4906 9.61747 9.68626 9.39516 9.82305 9.12634C9.94279 8.88153 10.0038 8.60414 9.99982 8.32288C9.99582 8.04163 9.92694 7.76671 9.80031 7.52658ZM4.99735 7.89495C4.9074 7.89495 4.81946 7.86409 4.74467 7.80626C4.66987 7.74844 4.61157 7.66625 4.57715 7.57009C4.54272 7.47394 4.53372 7.36813 4.55127 7.26605C4.56882 7.16397 4.61213 7.0702 4.67574 6.9966C4.73935 6.92301 4.82039 6.87289 4.90862 6.85258C4.99685 6.83228 5.0883 6.8427 5.17141 6.88253C5.25452 6.92236 5.32555 6.98981 5.37553 7.07635C5.4255 7.16289 5.45218 7.26463 5.45218 7.36871C5.45218 7.50828 5.40426 7.64213 5.31896 7.74082C5.23367 7.83951 5.11798 7.89495 4.99735 7.89495ZM5.45218 5.79C5.45218 5.92956 5.40426 6.06341 5.31896 6.1621C5.23367 6.26079 5.11798 6.31623 4.99735 6.31623C4.87673 6.31623 4.76104 6.26079 4.67574 6.1621C4.59045 6.06341 4.54253 5.92956 4.54253 5.79V3.68505C4.54253 3.54548 4.59045 3.41163 4.67574 3.31294C4.76104 3.21425 4.87673 3.15881 4.99735 3.15881C5.11798 3.15881 5.23367 3.21425 5.31896 3.31294C5.40426 3.41163 5.45218 3.54548 5.45218 3.68505V5.79Z"
      fill="currentColor"
    />
  </svg>
);

export default FailureIcon;
